import { useMemo } from 'react';

import type { ShareActionsOptions, ShareChannel } from '#src/app/shared/hooks/share';

import { useGetPetitionShareContent } from './content';
import { useOnPetitionShareSuccess } from './success';
import { useGetPetitionShareTrackingData } from './tracking';

export function usePetitionShareOptions(): ShareActionsOptions<ShareChannel> {
	const getContent = useGetPetitionShareContent();
	const getTrackingData = useGetPetitionShareTrackingData();
	const onSuccess = useOnPetitionShareSuccess();

	return useMemo(
		() => ({
			trackingEventName: 'share_petition',
			getContent,
			getTrackingData,
			onSuccess,
		}),
		[getContent, getTrackingData, onSuccess],
	);
}
